export function age(value, modifiers) {
  const getAge = value => {
    if (typeof value !== 'string') return false;
    const parts = value.split('.');
    if (parts.length !== 3) return false;
    if (parts[2].length !== 4) return false;
    const date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    if (!(date instanceof Date)) return false;
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    if (today.getMonth() < date.getMonth() || (today.getMonth() === date.getMonth() && today.getDate() < date.getDate())) {
      age--;
    }
    return age;
  }
  const age = getAge(value);
  return {
    valid: !value || (age && modifiers && modifiers.length === 1 && parseInt(modifiers[0]) <= age),
    errorMessage: 'Sie müssen mindestens ' + modifiers[0] + ' Jahre alt sein.',
  }
}
